/* ============================================================
   MARKET DWELLINGS — Product Page V2 JavaScript
   File: assets/md-product-v2.js
   ============================================================ */

(function () {
  'use strict';

  const D = window.mdProductData;
  if (!D) return;

  const variants      = D.variants;
  const options        = D.options;       // array of option names
  const minQty         = D.minQty || 1;
  const setSize        = D.setSize || 1;
  const isSetProduct   = D.isSetProduct;
  const productUnit    = D.productUnit || '';
  const swatchOption   = D.swatchOption || '';
  const productTitle   = D.productTitle || '';
  const recommendedQty = D.recommendedQty || '';
  const variantDescs   = (typeof D.variantDescriptions === 'string')
    ? tryParse(D.variantDescriptions) : (D.variantDescriptions || {});

  // Current selections: { "Material": "Corrugated Plastic", "Quantity": "10" }
  const selected = {};

  // Identify which option is the "quantity" option
  const qtyKeywords = ['quantity', 'qty', 'units', 'sets', 'pack', 'packs'];
  let qtyOptionName = null;
  options.forEach(name => {
    const lower = name.toLowerCase();
    qtyKeywords.forEach(kw => {
      if (lower.includes(kw)) qtyOptionName = name;
    });
  });

  // ── SVG GRAPHICS MAP ────────────────────────────────────
  const variantGraphics = {
    'corrugated-plastic': '<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><line x1="5" y1="4" x2="5" y2="24" stroke="currentColor" stroke-width="1.4" opacity="0.5"/><line x1="9" y1="4" x2="9" y2="24" stroke="currentColor" stroke-width="1.4" opacity="0.5"/><line x1="13" y1="4" x2="13" y2="24" stroke="currentColor" stroke-width="1.4" opacity="0.5"/><line x1="17" y1="4" x2="17" y2="24" stroke="currentColor" stroke-width="1.4" opacity="0.5"/><line x1="21" y1="4" x2="21" y2="24" stroke="currentColor" stroke-width="1.4" opacity="0.5"/></svg>',
    'pvc': '<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><rect x="4" y="4" width="20" height="20" rx="3" fill="#e8e3da" opacity="0.5"/><rect x="4" y="4" width="20" height="20" rx="3" stroke="currentColor" stroke-width="1"/></svg>',
    'aluminum-composite': '<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><defs><linearGradient id="acm" x1="0" y1="0" x2="28" y2="28"><stop offset="0%" stop-color="#ccc"/><stop offset="50%" stop-color="#eee"/><stop offset="100%" stop-color="#aaa"/></linearGradient></defs><rect x="4" y="4" width="20" height="20" rx="3" fill="url(#acm)"/><rect x="4" y="4" width="20" height="20" rx="3" stroke="#999" stroke-width="1"/></svg>',
    'no-holes': '<svg width="30" height="14" viewBox="0 0 30 14" fill="none"><rect x="1" y="1" width="28" height="12" rx="2" stroke="currentColor" stroke-width="1.3" fill="rgba(88,165,137,0.04)"/></svg>',
    '2-top-holes': '<svg width="30" height="14" viewBox="0 0 30 14" fill="none"><rect x="1" y="1" width="28" height="12" rx="2" stroke="currentColor" stroke-width="1.3" fill="rgba(0,0,0,0.02)"/><circle cx="9" cy="4.5" r="1.8" fill="none" stroke="currentColor" stroke-width="1"/><circle cx="21" cy="4.5" r="1.8" fill="none" stroke="currentColor" stroke-width="1"/></svg>',
    '2-top-2-bottom-holes': '<svg width="30" height="14" viewBox="0 0 30 14" fill="none"><rect x="1" y="1" width="28" height="12" rx="2" stroke="currentColor" stroke-width="1.3" fill="rgba(0,0,0,0.02)"/><circle cx="9" cy="4" r="1.6" fill="none" stroke="currentColor" stroke-width="1"/><circle cx="21" cy="4" r="1.6" fill="none" stroke="currentColor" stroke-width="1"/><circle cx="9" cy="10" r="1.6" fill="none" stroke="currentColor" stroke-width="1"/><circle cx="21" cy="10" r="1.6" fill="none" stroke="currentColor" stroke-width="1"/></svg>',
  };

  // ── INIT ──────────────────────────────────────────────────

  function init() {
    // Set initial selections from first variant
    options.forEach((name, i) => {
      const firstVariant = variants[0];
      if (firstVariant) {
        selected[name] = firstVariant['option' + (i + 1)];
      }
    });

    // Mark initial active — standard buttons
    document.querySelectorAll('.md-style-btn').forEach(btn => {
      const optName = btn.dataset.option;
      if (selected[optName] === btn.dataset.value) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // Mark initial active — swatch buttons
    document.querySelectorAll('.md-swatch-btn').forEach(btn => {
      const optName = btn.dataset.option;
      if (selected[optName] === btn.dataset.value) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // Set initial dropdown value
    const qtySelect = document.getElementById('md-qty-select');
    if (qtySelect && qtyOptionName && selected[qtyOptionName]) {
      qtySelect.value = selected[qtyOptionName];
    }

    // Populate variant descriptions and graphics
    populateVariantDescriptions();
    populateVariantGraphics();

    // Bind events
    bindStyleButtons();
    bindSwatchButtons();
    bindQtySelect();
    bindThumbnails();
    bindTabs();
    bindFaq();

    // Render initial state
    updateVariant();
    buildBulkPanel();
    filterImagesByVariant();
  }

  // ── VARIANT DESCRIPTIONS ──────────────────────────────────

  function populateVariantDescriptions() {
    document.querySelectorAll('.md-style-btn-desc').forEach(el => {
      const value = el.dataset.descFor;
      if (variantDescs && variantDescs[value]) {
        el.textContent = variantDescs[value];
        el.classList.add('has-desc');
      }
    });
  }

  // ── VARIANT GRAPHICS ──────────────────────────────────────

  function populateVariantGraphics() {
    document.querySelectorAll('.md-style-btn-graphic').forEach(el => {
      const handle = el.dataset.graphicFor;
      if (handle && variantGraphics[handle]) {
        el.innerHTML = variantGraphics[handle];
        el.classList.add('has-graphic');
      } else {
        el.style.display = 'none';
      }
    });
  }

  // ── STYLE BUTTON EVENTS ──────────────────────────────────

  function bindStyleButtons() {
    document.querySelectorAll('.md-style-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const optName = btn.dataset.option;
        const optVal = btn.dataset.value;
        selected[optName] = optVal;

        const grid = btn.closest('.md-style-grid');
        grid.querySelectorAll('.md-style-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        updateVariant();
        buildBulkPanel();
        filterImagesByVariant();
      });
    });
  }

  // ── SWATCH BUTTON EVENTS ─────────────────────────────────

  function bindSwatchButtons() {
    document.querySelectorAll('.md-swatch-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const optName = btn.dataset.option;
        const optVal = btn.dataset.value;
        selected[optName] = optVal;

        const grid = btn.closest('.md-swatch-grid');
        grid.querySelectorAll('.md-swatch-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        updateVariant();
        buildBulkPanel();
        filterImagesByVariant();
      });
    });
  }

  // ── IMAGE FILTERING BY VARIANT ────────────────────────────

  function filterImagesByVariant() {
    // Determine which option is the swatch/filterable option
    const filterOption = swatchOption || null;
    if (!filterOption) return; // No swatch option → show all images

    const filterValue = selected[filterOption];
    if (!filterValue) return;

    const thumbRow = document.getElementById('md-thumb-row');
    if (!thumbRow) return;

    const allThumbs = thumbRow.querySelectorAll('.md-thumb');

    // --- URL-based image-to-color matching ---
    // Uses variant featured_image URLs to match thumbnails to colors.
    // This is immune to alt text changes/resets because it relies on
    // the actual image file association, not metadata text.

    // Determine which option key (option1/option2/option3) is the swatch
    const swatchIdx = options.indexOf(filterOption);
    const swatchKey = 'option' + (swatchIdx + 1);

    // Build color → base image URL map from variant data
    const colorToUrl = {};
    variants.forEach(v => {
      const color = v[swatchKey];
      if (color && v.featured_image && v.featured_image.src && !colorToUrl[color]) {
        colorToUrl[color] = v.featured_image.src.split('?')[0];
      }
    });

    // Reverse map: base URL → color
    const urlToColor = {};
    for (const color in colorToUrl) {
      urlToColor[colorToUrl[color]] = color;
    }

    // Set of all color-associated URLs (to identify "universal" images)
    const allColorUrls = {};
    for (const color in colorToUrl) {
      allColorUrls[colorToUrl[color]] = true;
    }

    let firstVisible = null;
    let firstColorMatch = null;
    const filterLower = filterValue.toLowerCase();

    allThumbs.forEach(thumb => {
      const thumbBaseUrl = (thumb.dataset.src || '').split('?')[0];
      const thumbColor = urlToColor[thumbBaseUrl] || '';

      // Match: this thumbnail's image belongs to the selected color
      const isVariantMatch = thumbColor.toLowerCase() === filterLower;

      // Universal: image not tied to any color variant (e.g. lifestyle shot)
      const isUniversal = !allColorUrls[thumbBaseUrl];

      if (isVariantMatch || isUniversal) {
        thumb.style.display = '';
        if (!firstVisible) firstVisible = thumb;
        if (isVariantMatch && !firstColorMatch) firstColorMatch = thumb;
      } else {
        thumb.style.display = 'none';
        thumb.classList.remove('active');
      }
    });

    // Prefer color-matched image for hero; fall back to first visible
    let heroThumb = firstColorMatch || firstVisible;

    // ── Variant-level featured_image override ──
    // For combo products (Color + Message), the full variant's featured_image
    // is more specific than the swatch-only match above. Check the current
    // variant and use its featured_image if available.
    const currentVariant = findVariant();
    if (currentVariant && currentVariant.featured_image && currentVariant.featured_image.src) {
      const variantImgBase = currentVariant.featured_image.src.split('?')[0];
      allThumbs.forEach(t => {
        if (t.style.display !== 'none') {
          const tBase = (t.dataset.src || '').split('?')[0];
          if (tBase === variantImgBase) heroThumb = t;
        }
      });
    }

    // Always switch hero to the matched image
    if (heroThumb) {
      allThumbs.forEach(t => t.classList.remove('active'));
      heroThumb.classList.add('active');
      const mainImg = document.getElementById('md-main-img');
      if (mainImg && heroThumb.dataset.src) {
        const preload = new Image();
        preload.onload = () => {
          mainImg.style.opacity = '0';
          setTimeout(() => {
            mainImg.src = heroThumb.dataset.src;
            mainImg.style.opacity = '1';
          }, 150);
        };
        preload.src = heroThumb.dataset.src;
      }
    }
  }

  // ── QUANTITY SELECTOR ─────────────────────────────────────

  function bindQtySelect() {
    const qtySelect = document.getElementById('md-qty-select');
    if (!qtySelect || !qtyOptionName) return;

    qtySelect.addEventListener('change', () => {
      selected[qtyOptionName] = qtySelect.value;
      updateVariant();
      highlightBulkRow();
    });
  }

  // ── VARIANT RESOLUTION ────────────────────────────────────

  function findVariant() {
    return variants.find(v => {
      return options.every((name, i) => {
        return v['option' + (i + 1)] === selected[name];
      });
    });
  }

  function getQtyVariantsForCurrentSelection() {
    if (!qtyOptionName) return variants;

    return variants.filter(v => {
      return options.every((name, i) => {
        if (name === qtyOptionName) return true;
        return v['option' + (i + 1)] === selected[name];
      });
    });
  }

  function updateVariant() {
    const variant = findVariant();
    if (!variant) return;

    // Update hidden input
    const variantIdInput = document.getElementById('md-variant-id');
    if (variantIdInput) variantIdInput.value = variant.id;

    // Update total (price lives only in subtotal now)
    updateTotal(variant);

    // Update URL
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    // Update add to cart button state
    const atcBtn = document.getElementById('md-atc-btn');
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
    }
  }

  function updateTotal(variant) {
    const totalEl = document.getElementById('md-total');
    const savedEl = document.getElementById('md-total-saved');

    if (!variant) return;

    // Variant price IS the total (e.g. 20 riders at $225.60 = variant price $225.60)
    const total = variant.price / 100;
    if (totalEl) totalEl.textContent = formatMoney(total);

    // Calculate savings vs buying at the base (lowest qty) per-unit rate
    if (savedEl) {
      const baseVariants = getQtyVariantsForCurrentSelection();
      if (baseVariants.length > 1 && qtyOptionName) {
        const qtyIdx = options.indexOf(qtyOptionName);

        // Base variant: get its total price and qty to find per-unit rate
        const baseTotal = baseVariants[0].price / 100;
        const baseQty = parseInt(baseVariants[0]['option' + (qtyIdx + 1)], 10) || 1;
        const baseUnitPrice = baseTotal / baseQty;

        // Current variant qty
        const currentQty = parseInt(variant['option' + (qtyIdx + 1)], 10) || 1;
        const wouldHavePaid = baseUnitPrice * currentQty;
        const savedAmt = wouldHavePaid - total;

        if (savedAmt > 0.01) {
          savedEl.textContent = 'You save ' + formatMoney(savedAmt);
          savedEl.classList.add('visible');
        } else {
          savedEl.classList.remove('visible');
        }
      } else {
        savedEl.classList.remove('visible');
      }
    }
  }

  // ── BULK PRICING PANEL ────────────────────────────────────

  function pluralizeUnit(count) {
    if (!productUnit) return '';
    const num = parseInt(count, 10);
    if (num === 1) return ' ' + productUnit;
    if (productUnit.endsWith('s') || productUnit.endsWith('x') || productUnit.endsWith('ch') || productUnit.endsWith('sh')) {
      return ' ' + productUnit + 'es';
    }
    return ' ' + productUnit + 's';
  }

  function buildBulkPanel() {
    const panel = document.getElementById('md-bulk-panel');
    if (!panel || !qtyOptionName) return;

    const qtyVariants = getQtyVariantsForCurrentSelection();
    if (qtyVariants.length <= 1) {
      panel.innerHTML = '';
      return;
    }

    const qtyIdx = options.indexOf(qtyOptionName);

    // Build entries — variant price is the TOTAL, so derive per-unit price
    const entries = qtyVariants.map(v => {
      const num = parseInt(v['option' + (qtyIdx + 1)], 10) || 1;
      const totalPrice = v.price / 100;
      return {
        qtyVal: v['option' + (qtyIdx + 1)],
        num: num,
        price: totalPrice / num  // per-unit price for display
      };
    });
    const basePrice = entries[0].price; // per-unit price at lowest qty

    // Collapse consecutive same-price entries into tiers
    const tiers = [];
    let i = 0;
    while (i < entries.length) {
      const tier = {
        startVal: entries[i].qtyVal,
        startNum: entries[i].num,
        endVal: entries[i].qtyVal,
        endNum: entries[i].num,
        price: entries[i].price,
        variants: [entries[i].qtyVal]
      };
      while (i + 1 < entries.length && entries[i + 1].price === tier.price) {
        i++;
        tier.endVal = entries[i].qtyVal;
        tier.endNum = entries[i].num;
        tier.variants.push(entries[i].qtyVal);
      }
      tiers.push(tier);
      i++;
    }

    let html = '';
    tiers.forEach((tier, idx) => {
      const price = tier.price;
      const isRange = tier.variants.length > 1;
      const isLast = idx === tiers.length - 1;
      const isActive = tier.variants.includes(selected[qtyOptionName]);

      let saveHtml = '';
      if (idx === 0) {
        saveHtml = '<span class="md-bulk-save empty">\u00a0</span>';
      } else {
        const pct = Math.round((1 - price / basePrice) * 100);
        if (pct > 0) {
          saveHtml = '<span class="md-bulk-save">Save ' + pct + '%</span>';
        } else {
          saveHtml = '<span class="md-bulk-save empty">\u00a0</span>';
        }
      }

      let qtyLabel;
      if (isRange) {
        if (isLast) {
          qtyLabel = tier.startNum + '+';
        } else {
          qtyLabel = tier.startNum + ' \u2013 ' + tier.endNum;
        }
        if (productUnit) qtyLabel += pluralizeUnit(2);
      } else {
        if (!isNaN(tier.startNum) && productUnit) {
          qtyLabel = tier.startNum + pluralizeUnit(tier.startNum);
        } else {
          qtyLabel = tier.startVal;
        }
      }

      // Check if this tier contains the recommended qty
      const isRecommended = recommendedQty && tier.variants.includes(recommendedQty);

      html += '<div class="md-bulk-row' + (isActive ? ' active' : '') + (isRecommended ? ' recommended' : '') + '" data-qty-value="' + escapeAttr(tier.startVal) + '" data-tier-values="' + escapeAttr(tier.variants.join(',')) + '">'
        + (isRecommended ? '<span class="md-bulk-badge">Most Popular</span>' : '')
        + '<span class="md-bulk-qty">' + qtyLabel + '</span>'
        + '<span class="md-bulk-price">' + formatMoney(price) + ' ea</span>'
        + saveHtml
        + '</div>';
    });

    panel.innerHTML = html;

    // Bind click on bulk rows
    panel.querySelectorAll('.md-bulk-row').forEach(row => {
      row.addEventListener('click', () => {
        const val = row.dataset.qtyValue;
        selected[qtyOptionName] = val;

        const qtySelect = document.getElementById('md-qty-select');
        if (qtySelect) {
          const option = qtySelect.querySelector('option[value="' + CSS.escape(val) + '"]');
          if (option) qtySelect.value = val;
        }

        updateVariant();
        highlightBulkRow();
      });
    });
  }

  function highlightBulkRow() {
    const panel = document.getElementById('md-bulk-panel');
    if (!panel) return;

    const currentVal = selected[qtyOptionName];
    panel.querySelectorAll('.md-bulk-row').forEach(row => {
      const tierValues = (row.dataset.tierValues || '').split(',');
      if (tierValues.includes(currentVal)) {
        row.classList.add('active');
      } else {
        row.classList.remove('active');
      }
    });
  }

  // ── THUMBNAILS ────────────────────────────────────────────

  function bindThumbnails() {
    document.querySelectorAll('.md-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        document.querySelectorAll('.md-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');

        const mainImg = document.getElementById('md-main-img');
        if (mainImg && thumb.dataset.src) {
          mainImg.style.opacity = '0';
          setTimeout(() => {
            mainImg.src = thumb.dataset.src;
            mainImg.style.opacity = '1';
          }, 150);
        }
      });
    });
  }

  // ── TABS ──────────────────────────────────────────────────

  function bindTabs() {
    document.querySelectorAll('.md-tab-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;
        const section = btn.closest('.md-tabs-section');
        if (!section) return;

        section.querySelectorAll('.md-tab-btn').forEach(b => b.classList.remove('active'));
        section.querySelectorAll('.md-tab-panel').forEach(p => p.classList.remove('active'));

        btn.classList.add('active');
        const panel = section.querySelector('#' + target);
        if (panel) panel.classList.add('active');
      });
    });
  }

  // ── FAQ ───────────────────────────────────────────────────

  function bindFaq() {
    document.querySelectorAll('.md-faq-q').forEach(q => {
      q.addEventListener('click', () => {
        const item = q.closest('.md-faq-item');
        if (item) item.classList.toggle('open');
      });
    });
  }

  // ── HELPERS ───────────────────────────────────────────────

  function formatMoney(amount) {
    return '$' + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function escapeAttr(str) {
    return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function tryParse(str) {
    try { return JSON.parse(str); } catch (e) { return {}; }
  }

  // ── LAUNCH ────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
